"use client";

import createIcon from './util/createIcon';
export default createIcon('M8 3H16C18.76 3 21 5.24 21 8V16C21 18.76 18.76 21 16 21H8C5.24 21 3 18.76 3 16V8C3 5.24 5.24 3 8 3Z', 'SquareRounded');